var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10587_14100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6654 0.833313C13.2819 0.833313 12.8981 0.979782 12.6055 1.27212L11.7799 2.09764L13.901 4.21873L14.7266 3.39321C15.3112 2.80788 15.3112 1.85875 14.7266 1.27342L14.7253 1.27212C14.4326 0.979782 14.0489 0.833313 13.6654 0.833313ZM3.33203 2.16665C1.95136 2.16665 0.832031 3.28598 0.832031 4.66665V12.6666C0.832031 14.0473 1.95136 15.1666 3.33203 15.1666H11.332C12.7127 15.1666 13.832 14.0473 13.832 12.6666V6.90232C13.832 6.62632 13.608 6.40232 13.332 6.40232C13.056 6.40232 12.832 6.62632 12.832 6.90232V12.6666C12.832 13.4953 12.1607 14.1666 11.332 14.1666H3.33203C2.50336 14.1666 1.83203 13.4953 1.83203 12.6666V4.66665C1.83203 3.83798 2.50336 3.16665 3.33203 3.16665H9.09635C9.37235 3.16665 9.59635 2.94265 9.59635 2.66665C9.59635 2.39065 9.37235 2.16665 9.09635 2.16665H3.33203ZM11.0716 2.80467L6.71094 7.16534C6.65627 7.22001 6.61581 7.28796 6.59115 7.36196L5.88411 9.48305C5.82411 9.66238 5.87121 9.85947 6.00521 9.99347C6.13921 10.1275 6.33629 10.1746 6.51562 10.1146L8.63672 9.40753C8.71072 9.38286 8.77867 9.34241 8.83333 9.28774L13.194 4.92706L11.0716 2.80467Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10587_14100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.c24dfd83fa949716740278eddc444b78.svg";
export { ForwardRef as ReactComponent };